// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GQt1H","top":"styles_top__VxgKp"};